import { AvailableServices } from '@vendasta/integrations';

export const BOOKING_LINK = 'MEETING_SCHEDULER.BOOKING_LINK.BREADCRUMB';

export const INVALID_MEETING_ID = 'invalid_meeting_id';

export const CURRENT_VIEW = 'settings';

export const MEETING_SCHEDULER_CONTEXT_INJECTION_TOKEN$ = 'MS_CONTEXT';
export const PERSONAL_EVENT_TYPE = 'Personal event type';
export const TEAM_EVENT_TYPE = 'Team event type';
export const GROUP = 'group';
export const SERVICE = 'service';
export const EVENTS = 'events';

export const CALENDAR_ID_PREFIX = 'MCAL-';
export const GROUP_ID_PREFIX = 'GRP-';
export const SERVICE_ID_PREFIX = 'SVS-';

export const GRID_VIEW = 'grid';
export const LIST_VIEW = 'list';

export enum MS_CONTEXT {
  MS_CONTEXT_PARTNER,
  MS_CONTEXT_SMB,
}

export const GOOGLE_MAP_URL_PREFIX = 'https://www.google.com/maps?q=';

export const getCalendarProviderDisplayName = (provider: string): string => {
  switch (provider) {
    case CALENDAR_SOURCE.GOOGLE:
      return 'Google Calendar';
    case CALENDAR_SOURCE.MICROSOFT:
      return 'Outlook Calendar';
    default:
      return provider;
  }
};

export const getMeetingAppDisplayName = (meetingApp: AvailableServices): string => {
  switch (meetingApp) {
    case AvailableServices.GOOGLE_MEET:
      return 'Google Meet';
    case AvailableServices.ZOOM:
      return 'Zoom';
    case AvailableServices.MICROSOFT:
      return 'Microsoft Teams';
    default:
      return '';
  }
};

export const POSTHOG_KEYS = {
  SETUP_WIZARD_OPENED: 'meeting-scheduler-setup-wizard-opened',
  STEP_1_COMPLETED: 'meeting-scheduler-step-1-completed',
  STEP_2_COMPLETED: 'meeting-scheduler-step-2-completed',
  STEP_3_COMPLETED: 'meeting-scheduler-step-3-completed',
  STEP_4_COMPLETED: 'meeting-scheduler-step-4-completed',
  EVENT_TYPE_CREATED: 'meeting-scheduler-event-type-created',
  GROUP_CREATED: 'meeting-scheduler-group-created',
  SERVICE_CREATED: 'meeting-scheduler-service-created',
  EVENT_TYPE_UPDATED: 'meeting-scheduler-event-type-updated',
  GROUP_UPDATED: 'meeting-scheduler-group-updated',
  SERVICE_UPDATED: 'meeting-scheduler-service-updated',
  EVENT_TYPE_DELETED: 'meeting-scheduler-event-type-deleted',
  GROUP_DELETED: 'meeting-scheduler-group-deleted',
  SERVICE_DELETED: 'meeting-scheduler-service-deleted',
  MEETING_JOINED: 'meeting-scheduler-meeting-joined',
  MEETING_RESCHEDULED: 'meeting-scheduler-meeting-rescheduled',
  MEETING_CANCELLED: 'meeting-scheduler-meeting-cancelled',
  MEETING_BOOKED_FROM_MY_MEETINGS: 'meeting-scheduler-meeting-booked-from-my-meetings',
  VIEW_EVENT_LINK: 'meeting-scheduler-view-event-link',
  HOST_PREFERENCE_UPDATED: 'meeting-scheduler-host-preference-updated',
  VIEW_MY_MEETINGS: 'meeting-scheduler-view-my-meetings',
  CALENDAR_PROVIDER_SELECTED: 'meeting-scheduler-calendar-provider-selected',
  MEETING_APP_SELECTED: 'meeting-scheduler-meeting-app-selected',
  CALENDAR_PROVIDER_CHANGED: 'meeting-scheduler-calendar-provider-changed',
  MEETING_APP_CHANGED: 'meeting-scheduler-meeting-app-changed',
  MULTI_HOST_EVENT_TYPE_CREATED: 'meeting-scheduler-multi-host-event-type-created',
  PRIORITY_ASSIGNMENT_EVENT_TYPE_CREATED: 'meeting-scheduler-priority-assignmemt-event-type-created',
  SESSION_EVENT_TYPE_CREATED: 'meeting-scheduler-session_event-type_created',
  SESSION_EVENT_TYPE_UPDATED: 'meeting-scheduler-session_event-type_updated',
  SESSION_EVENT_TYPE_SCHEDULED: 'meeting-scheduler-session_event-type_scheduled',
};

export const POSTHOG_CATEGORIES = {
  USER: 'user',
};

export const POSTHOG_ACTIONS = {
  CLICK: 'click',
};

export const BOOOKING_URL_DEMO = 'https://meetings-demo.apigateway.co';
export const BOOOKING_URL_PROD = 'https://bookmenow.info';

export const CALENDAR_SOURCE = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
};
